import withAccordionPages from './with-accordion-pages';

export default withAccordionPages;